
const QueryKey = {
    img: "img",
    comDashboard: 'comDashboard',
    comUserProfile: 'comUserProfile',
    amtcDashboard: 'amtcDashboard',
    amtcCat: "amtcCat",
    amtcSubCat: "amtcSubCat",
    amtcProd: "amtcProd",
    singleCat: "singleCat",
    amtcProdInfo: "amtcProdInfo",
    comList: "comList",
    singleCom: "singleCom",
    projList: "projList",
    comCatList: "comCatList",
    comProd: "comProd",
    comSubCatList: "comSubCatList",
    apprProdList: "apprProdList",
    prodStockList: "prodStockList",
    comEmpList: "comEmpList",
    projListDD: "projListDD",
    projInfo: "projInfo",
    comAssiUserDD: "comAssiUserDD",
    deptEmpList: "deptEmpList",
    amtcEmpList: "amtcEmpList",
    comListDD: "comListDD",
    cartList: "cartList",
    prodReqList: "prodReqList",
    prodReqInfo: "prodReqInfo",
    getComAddProdSrch: "getComAddProdSrch",
    newProdReqList: "newProdReqList",
    singleNewProdReq: "singleNewProdReq",
    deptListDD: "deptListDD",
    poList: "poList",
    poInfo: "poInfo",
    notApprEmp: "notApprEmp",
    doInfo: "doInfo",
    doEditInfo: "doEditInfo",
    poTracking: "poTracking",
    poProdInfo: "poProdInfo",
    notify: "notify",
    archivedProds: "archivedProds",
    potInfo: "potInfo",
    potProdInfo: "potProdInfo",
}

export default QueryKey;